import { NavigationGuard } from 'vue-router';

const LPUrl: { [key in typeof process.env.VUE_APP_ENV]: string } = {
  e2e: 'http://localhost:8080',
  development: 'http://localhost:8080',
  production: 'https://chemican.com',
  staging: 'https://stg.chemican.com',
};

const getEnvironmentBasedRedirectUrl = (basePath: string) => {
  const baseUrl = LPUrl[process.env.VUE_APP_ENV] || '';

  return baseUrl + basePath;
};

type RedirectToChemicanLP = (path: string) => NavigationGuard;

export const redirectToChemicanLP: RedirectToChemicanLP =
  (path) => (_, __, next) => {
    if (
      process.env.VUE_APP_ENV === 'development' ||
      process.env.NODE_ENV === 'development'
    ) {
      next();
      return;
    }

    window.location.href = getEnvironmentBasedRedirectUrl(path);
  };
